export function getTenantAppUrl(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    if (host.includes('simplyforyou.business')) {
      return 'https://simplyforyou.business';
    }
    if (host.includes('simplyforyou.online')) {
      return 'https://simplyforyou.online';
    }
    if (host === '159.198.36.186') {
      return 'http://159.198.36.186';
    }
  }

  const raw = import.meta.env.VITE_TENANT_APP_URL as string | undefined;
  if (raw?.trim()) {
    return raw.trim().replace(/\/$/, '');
  }

  return 'https://simplyforyou.business';
}

export function buildTenantLoginUrl(_workspaceSlug?: string): string {
  return `${getTenantAppUrl()}/login`;
}

export function buildTenantHandoffUrl(hashPayloadBase64: string): string {
  return `${getTenantAppUrl()}/auth/handoff#${hashPayloadBase64}`;
}

export function buildTenantPortalUrl(domainSlug: string): string | null {
  return buildTenantLoginUrl(domainSlug);
}

export function resolveTenantPortalUrl(slugOrUrl: string): string | null {
  const value = slugOrUrl.trim();
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  return buildTenantLoginUrl(value);
}
